export const normalizeBarcode = (value, addDash) => {
  if (!value) {
    return value;
  }
  let validCharacters = value.replace(/[^a-zA-Z0-9]/, "");
  validCharacters = validCharacters.substring(0, 64);

  if (!addDash) {
    return validCharacters
  }

  // decorating input
  return validCharacters.length === 0
    ? ""
    : validCharacters.length <= 4
    ? `${validCharacters.substring(0, 4)}`
    : `${validCharacters.substring(0, 4)}-${validCharacters.substring(4, 12)}`;
};
